/**
 * The three views of the address book. Favourites and Branches are subsets of
 * All; which one opens first depends on what the customer actually has.
 *
 * The values are the ids ui-core `Tabs` uses, so the screen can hand its
 * selection straight to the controlled `activeTab` with nothing in between.
 */
export const LocationsAddressBookTabs = {
  FavouriteLocations: "favourites",
  BranchLocations: "branches",
  AllLocations: "all",
} as const;

export type LocationsAddressBookTabs =
  (typeof LocationsAddressBookTabs)[keyof typeof LocationsAddressBookTabs];
